import { ToggleButtonGroup, ToggleButton } from '@mui/material';
import { alpha } from '@mui/material/styles';
import React from 'react';
import { useAppDispatch, useAppSelector } from '../hooks';
import { Locale, selectSettings, setLocalePersistent } from '../../features/settings/settingsSlice';

export type LanguageValue = Locale;

type Props = {
    onChange?: (value: LanguageValue) => void;
};

export function LanguageToggle({ onChange }: Props) {
    const dispatch = useAppDispatch();
    const { locale } = useAppSelector(selectSettings);

    const handleLangChange = (_: React.MouseEvent<HTMLElement>, newValue: LanguageValue | null) => {
        if (!newValue) return;
        dispatch(setLocalePersistent(newValue as Locale));
        onChange?.(newValue);
    };

    return (
        <ToggleButtonGroup
            exclusive
            value={locale}
            onChange={handleLangChange}
            size="small"
            sx={(t) => ({
                '& .MuiToggleButton-root': {
                    textTransform: 'none',
                    fontWeight: 600,
                    border: `1px solid ${t.palette.divider}`,
                    '&:hover': { backgroundColor: t.palette.action.hover },
                    '&.Mui-selected': {
                        color: t.palette.primary.main,
                        borderColor: t.palette.primary.main,
                        backgroundColor: alpha(t.palette.primary.main, 0.10),
                        '&:hover': { backgroundColor: alpha(t.palette.primary.main, 0.16) },
                    },
                },
            })}
        >
            <ToggleButton value="pl">PL</ToggleButton>
            <ToggleButton value="en-US">EN</ToggleButton>
            <ToggleButton value="de">DE</ToggleButton>
        </ToggleButtonGroup>
    );
}
